import type { ReactNode } from "react";
import { Route } from "react-router-dom";

/**
 * Registry dizisini `<Route>` dizisine çevirir.
 *
 * `App.tsx` GERÇEK element'le, `__tests__/route-resolution.test.tsx` STUB'la
 * çağırır — ikisi ARTIK aynı fonksiyonu kullandığı için index/path/key eşlemesi
 * SAPAMAZ (B3). Önceden iki dosya ayrı ayrı `ROUTES.map(...)` yapıyordu; biri
 * değişip diğeri değişmezse test sessizce yanlış ağacı doğruluyordu.
 *
 * ── Dürüst sınır ──────────────────────────────────────────────────────────
 * Yalnız İÇ `.map()`'i tekilleştirir. Hangi `<Route>`'un hangi layout'u SARDIĞI
 * (dış topoloji) hâlâ elle eşlenir — daha kaba taneli, çok daha seyrek değişen
 * bir risk; `nav-registry.test.ts`'in zaten kabul ettiği sınıf.
 *
 * ⚠️ 2026-07-28 mutasyon testi: App.tsx'in dış topolojisi (ProtectedRoute+Layout
 * sarmalayıcısı) bozulduğunda route-resolution testi YEŞİL KALIYOR — hiçbir test
 * gerçek App.tsx'i import etmiyor, harness kendi kopyasını kuruyor. Yani bu sınır
 * ÖLÇÜLDÜ ve AÇIK: dış topoloji değişikliği otomatik yakalanmaz, elle eşlenmeli.
 */
export function buildRouteElements<R extends { routePath?: string }>(
  routes: R[],
  renderElement: (r: R) => ReactNode
) {
  return routes.map((r) => (
    <Route
      key={r.routePath ?? "index"}
      index={r.routePath === undefined}
      path={r.routePath}
      element={renderElement(r)}
    />
  ));
}
